import { useRef, useEffect, useState } from "react";
import { AuditlogConfig } from "./data/AuditlogConfig";
import Buttons from "../../../components/ui/button/Buttons";
import Accordion from "../../../components/Accordion/Accordion";
import { AuditlogData } from "./data/ProductsApplicationDetails.data";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import FormCreator from "../../../components/Forms/FormCreator";
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import MolGrid from "../../../components/Grid/MolGrid";
import ApplicationInformation from "./features/ApplicationInformation/ApplicationInformation";
import SelfEvaluationInfo from "./features/SelfEvaluationInformation/SelfEvaluationInfo";
import { useGetSGBPSApplicationAuditLogListMutation, useLazyGetUpdatedByDropdownForAuditLogQuery } from "../../../app/services/CertificateGrouping/certificateGroupingApi";
import { decryptAESID } from "../../../utils/Encryption";
import CertificateGroupingView from "./features/CertificateGrouping/CertificateGrouping";

const ProductsApplicationDetails = () => {
  const { id, id3,id2 } = useParams();
  const navigate = useNavigate()
  const tempId = id3 ? decryptAESID(id3, false) : 0;
  const editID = id ? decryptAESID(id, false) : 0;
  const corporatememberId = id2 ? decryptAESID(id2, false) : 0;
  
  const AuditlogRef = useRef();
  const molGridRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [formData, setFormData] = useState(AuditlogData);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    SGBPSApplicationId: Number(editID),
    SearchText: null,
    DateFrom: null,
    DateTo: null,
    UpdatedBy: null,
    totalCount: 0,
  });

  const [getSGBPSApplicationAuditLogList, { isLoading: getSGBPSApplicationAuditLogListLoading, isSuccess: getSGBPSApplicationAuditLogListSuccess, data: getSGBPSApplicationAuditLogListData }] = useGetSGBPSApplicationAuditLogListMutation()
  const [getUpdatedByDropdownForAuditLog, { isLoading: getUpdatedByDropdownForAuditLogLoading, isSuccess: getUpdatedByDropdownForAuditLogSuccess, data: getUpdatedByDropdownForAuditLogData }] = useLazyGetUpdatedByDropdownForAuditLogQuery()

  useEffect(() => {
    if (editID > 0) {
      getUpdatedByDropdownForAuditLog(editID);
    }
  }, [editID])

  useEffect(() => {
    if (!getUpdatedByDropdownForAuditLogLoading && getUpdatedByDropdownForAuditLogData) {
      setAllDropDownField(getUpdatedByDropdownForAuditLogData, setFormData);
    }
  }, [getUpdatedByDropdownForAuditLogLoading, getUpdatedByDropdownForAuditLogData]);

  const setAllDropDownField = (apiResponse, setFormData) => {
    const updatedByList = (apiResponse || []).map((item) => ({
      value: item.id,
      label: item.name,
    }));

    const dropdownLists = {
      updatedBy: updatedByList,
    };

    setFormData((prev) => ({
      ...prev,
      formFields: prev.formFields.map((field) => {
        const options = dropdownLists[field?.id];
        return options
          ? { ...field, fieldSetting: { ...field.fieldSetting, options } }
          : field;
      }),
    }));
  };

  const pad = (n) => String(n).padStart(2, "0");

  const formatDateOnly = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const formatDateTime = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDataSource([]);
    setFormData({ ...AuditlogData });
    if (getUpdatedByDropdownForAuditLogData) {
      setAllDropDownField(getUpdatedByDropdownForAuditLogData, setFormData);
    }
    setPaginationRequest((prev) => ({
      ...prev,
      pageNo: 1,
      pageSize: 10,
      SearchText: null,
      DateFrom: null,
      DateTo: null,
      UpdatedBy: null,
      totalCount: 0,
    }));
  };

  const handleSearch = () => {
    const auditFormData = AuditlogRef?.current?.getFormData();
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: 1,
      pageSize: 10,
      SGBPSApplicationId: Number(editID),
      SearchText: auditFormData?.searchByDescription || null,
      DateFrom: formatDateOnly(auditFormData?.fromDate),
      DateTo: formatDateOnly(auditFormData?.toDate),
      UpdatedBy: auditFormData?.updatedBy?.label || null,
    };
    setPaginationRequest(updatedPaginationRequest);
    getSGBPSApplicationAuditLogList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      description: null,
      fromDate: null,
      toDate: null,
      updatedBy: null,
    };

    const request = {
      ...paginationRequest,
      pageNo: 1,
      SearchText: null,
      DateFrom: null,
      DateTo: null,
      UpdatedBy: null,
    };

    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getSGBPSApplicationAuditLogList(request);
    setFormData(updatedFormData);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    getSGBPSApplicationAuditLogList(updatedPaginationRequest);
  };

  useEffect(() => {
    if (isModalOpen && editID) {
      getSGBPSApplicationAuditLogList({
        ...paginationRequest,
        pageNo: 1,
        SGBPSApplicationId: Number(editID),
      });
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (!getSGBPSApplicationAuditLogListLoading && getSGBPSApplicationAuditLogListSuccess && getSGBPSApplicationAuditLogListData) {
      setPaginationRequest((prev) => ({
        ...prev, totalCount: getSGBPSApplicationAuditLogListData?.totalCount,
      }));
      const auditList = getSGBPSApplicationAuditLogListData?.itemList?.map(
        (item) => ({
          ...item,
          dateTime: formatDateTime(item?.createdDate),
        })
      );
      setDataSource(auditList || []);
    }
  }, [getSGBPSApplicationAuditLogListLoading, getSGBPSApplicationAuditLogListSuccess, getSGBPSApplicationAuditLogListData,]);

  return (
    <div className="products-application-details-page">
      <div className="d-flex gap-3 mb-4 justify-content-end">
        <Buttons
          buttonText="Audit Log"
          buttonTypeClassName="success-btn"
          onClick={openModal}
        />
      </div>
      <ApplicationInformation />

      <Accordion
        title="Self Evaluation Information"
        className="mb-4"
        button={false}
        accordion={true}
      >
        <SelfEvaluationInfo />
      </Accordion>
      <Accordion title="Certificate Grouping"
        className="mb-4"
        button={false}
        accordion={true}>
        <CertificateGroupingView certificateId={tempId} />
      </Accordion>

      <div className="d-flex justify-content-between mt-4">
        <Buttons
          buttonText="Back"
          buttonTypeClassName="black-btn"
          onClick={() => (navigate(`/viewCertificateCorporateAccountPage/${id2}`))}
        />
      </div>

      {/* Center Modal  */}

      {isModalOpen && (
        <CenterModel
          modelTitle={""}
          show={isModalOpen}
          handleClose={closeModal}
        >
          <div className="crud-requirement-list">
            <div className="corporate-member-list">
              <div className="sgbp-category">
                <div className="row w-100">
                  <div className="col-10 row">
                    {getUpdatedByDropdownForAuditLogData &&
                      <FormCreator
                        ref={AuditlogRef}
                        {...formData} />
                    }
                  </div>
                  <div className="col-2 audit-btn-group">
                    <Buttons
                      buttonText="Search"
                      buttonTypeClassName="search-btn "
                      onClick={handleSearch}
                    />
                    <Buttons
                      buttonText="Clear"
                      buttonTypeClassName="btn btn-secondary"
                      onClick={handleClearClick}
                    />
                  </div>
                </div>
              </div>

              <div className="audit-log-list model-audit-log-list">
                <MolGrid
                  ref={molGridRef}
                  configuration={AuditlogConfig}
                  dataSource={dataSource}
                  isLoading={getSGBPSApplicationAuditLogListLoading}
                  allowPagination={true}
                  pagination={paginationRequest}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </CenterModel>
      )}
    </div>

  );
};

export default ProductsApplicationDetails;
